import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from "./components/loader/loader.component";
import { AlertComponent } from './components/alert/alert.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderShowHideService } from './shared/utils/headerShowHide.service';
import { LoaderService } from './services/loader/loader.service';
import { NgClass } from '@angular/common';
import { LocationService } from './shared/utils/location.service';
import { environment } from '../environments/environment';
declare var bootstrap: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, AlertComponent, HeaderComponent, FooterComponent, NgClass],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'gail-app';
  public headerHide: boolean = true;
  modalRef: any;
  loaderService = inject(LoaderService);
  locationService = inject(LocationService);
  position: any;
  constructor(private headerService : HeaderShowHideService){
    
  }
  ngOnInit() {
   
    

    this.getLocation();
    if (environment.disableConsoleLogging) {
      console.log = function() {};
      console.warn = function() {};
      console.info = function() {};
      console.debug = function() {};
      console.error = function() {};
  }
  }
  ngAfterViewInit() {

    this.headerService.headerStatus.subscribe((val: boolean) => {
     const authUser = localStorage.getItem('authUser');
     if (authUser) {
       //alert('show')
      this.headerHide = false;
      this.loaderService.setLoggedInStatus(true);
     } else {
       //alert('hide')
       this.headerHide = true;
      this.loaderService.setLoggedInStatus(false);
    }
    });
    
    const modalElement = document.getElementById('modal-location');
    if (modalElement) {
      this.modalRef = new bootstrap.Modal(modalElement);
    }

    
  }

  showModal() {
    if (this.modalRef) {
      this.modalRef.show();
    }
  }
  hideModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  getLocation() {
    this.locationService.getCurrentLocation().then((position) => {
      console.log('position', position);
      this.position = position;
      //localStorage.setItem('coords', JSON.stringify(position));
      this.hideModal();

      if (this.position == undefined || this.position == null) {
        this.position = {lat : 1.000, lng: 1.000}
      }

    }).catch((error) => {
      console.log('error', error);
      this.showModal();
    });
  }
}
